export default "__VITE_ASSET__BsWpEzg6__"